module.exports = __webpack_public_path__ + "app/principal/principal-documentary-space-f1xDdMuV.html";